export const GET_TYPE_PROCESS = 'GET_TYPE_PROCESS'
export const GET_TYPE_PROCESS_EXITO = 'GET_TYPE_PROCESS_EXITO'
export const GET_TYPE_PROCESS_ERRROR = 'GET_TYPE_PROCESS_ERROR'
